export default __webpack_public_path__ + "static/Garage-Demolition-7222e6e095c14429e04d460d539ddcef.jpg";